export const isSatisfyOption = <T>(availableOptions: T[] | readonly T[], value: T | undefined | null): boolean => {
  return !!value && availableOptions.includes(value);
};
